<template>
  <PageSecondary class="burnout">
    <template #title>Помощь при выгорании?</template>
    <h4>Бесплатная 25 минутная консультация на тему выгорания на работе или в отношениях.</h4>

    <img src="@/assets/handdrawn/forest-fire.jpg">

    <span>
      Я просто искренне хочу помогать и помогаю людям с выгоранием. Без воды и реклам, по делу и по факту. На видео-звонке быстро пробежимся по 3 пунктам.
    </span>

    <ul>
      <li>
        Причины твоего выгорания
      </li>
      <li>
        Что происходит с тобой сейчас
      </li>
      <li>
        Что тебе хочется и как туда прийти
      </li>
    </ul>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";

export default {
  name: "Past",
  components: {PageSecondary}
}
</script>

<style lang="scss" scoped>
.burnout {
  span {
    display: block;
    margin-top: 24px;
  }

  img {
    width: 100%;
    margin-top: 24px;
  }

  h4 {
    margin-top: 40px;
  }
}
</style>
